var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-timepicker',{staticClass:"is-shadowless",attrs:{"inline":"","incrementMinutes":5,"hour-format":_vm.company.timeFormat},on:{"input":_vm.onChange},model:{value:(_vm.dateTime),callback:function ($$v) {_vm.dateTime=$$v},expression:"dateTime"}})
}
var staticRenderFns = []

export { render, staticRenderFns }